import styled, { css } from "styled-components";

export const CardRoot = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);

  &:hover {
    transform: scale(1.05);
  }
`;

export const IdBadge = styled.div`
  max-width: 95%;
  background: #fff;
  border-radius: 1.5rem;
  padding: 0.5rem 1.5rem;
  margin: 0 auto;
  transform: translateY(50%);
  z-index: 2;
  box-shadow:
    0 -10px 15px -3px rgba(0, 0, 0, 0.1),
    0 -4px 6px -4px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-secondary);
  line-height: 1.3;

  b {
    font-weight: 700;
  }

  @media (min-width: 1280px) {
    font-size: 0.875rem;
  }

  @media (min-width: 1536px) {
    font-size: 1rem;
  }
`;

export const CoverImage = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 1rem;
  cursor: pointer;
  display: block;

  @media (min-width: 1024px) {
    height: 350px;
  }
`;

export const InfoPanel = styled.div`
  width: 95%;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 1rem 1.5rem 1.5rem;
  border-radius: 0 0 1.5rem 1.5rem;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);
  z-index: 3;
`;

export const Description = styled.p`
  margin: 0;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (min-width: 1280px) {
    font-size: 0.875rem;
  }

  @media (min-width: 1536px) {
    font-size: 1rem;
  }
`;

export const ExpandDetails = styled.div<{ $open: boolean }>`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition:
    grid-template-rows 0.35s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.3s ease,
    margin 0.3s ease;
  margin-top: ${({ $open }) => ($open ? "1rem" : "0")};

  .expand-inner {
    min-height: 0;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 0.5rem;
  }
`;

export const PriceBlock = styled.div`
  p {
    margin: 0;
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--color-secondary);

    @media (min-width: 1280px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1536px) {
      font-size: 1rem;
    }

    &.disclaimer {
      font-size: 0.75rem;
    }
  }

  & > div {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  b {
    display: block;
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--color-secondary);

    @media (min-width: 1280px) {
      font-size: 1rem;
    }

    @media (min-width: 1536px) {
      font-size: 1.125rem;
    }
  }
`;

export const UnitBlock = styled.div`
  p {
    margin: 0;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--color-secondary);
    text-align: right;

    @media (min-width: 1280px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1536px) {
      font-size: 1rem;
    }
  }
`;

export const ToggleButton = styled.button<{ $open: boolean }>`
  width: fit-content;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  place-items: center;
  background: var(--color-secondary);
  color: #fff;
  border: none;
  padding: 0.25rem 1.25rem;
  border-radius: 0 0 1.5rem 1.5rem;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: var(--color-primary);
  }

  svg {
    width: 1.1rem;
    height: 1.1rem;
    transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);

    ${({ $open }) =>
      $open &&
      css`
        transform: rotate(180deg);
      `}
  }
`;
